var number2color = require('./number2color');

module.exports = {
  number2color: number2color,
  numberToColor: number2color,
  parsePath: require('./parse-path'),
  parseRadius: require('./parse-radius')
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_util@1.3.1@@antv/util/lib/format/index.js
// module id = 205
// module chunks = 0